import React from 'react';

import { ACTION_STYLE_TYPE, getActionConfigByType, TpColumnConfig } from './interfaces';

export function getCellStyle(columnConfig: TpColumnConfig) {
  const style: React.CSSProperties = {};
  if (columnConfig.bold) style.fontWeight = 'bold';
  return style;
}

function isIconOnlyAction(columnConfig: TpColumnConfig) {
  if (!columnConfig.action) return false;
  const actionTypeConfig = getActionConfigByType(columnConfig.action.type);
  const styleType = columnConfig.action.actionStyle ?? actionTypeConfig?.defaultPresentationType;
  return styleType === ACTION_STYLE_TYPE.ICON;
}

/**
 * Is this column a utility column.
 * Currently defined as column with an icon-only action.
 */
export function isUtilityColumn(columnConfig: TpColumnConfig) {
  return isIconOnlyAction(columnConfig);
}

export function getColumnWidth(columnConfig: TpColumnConfig, defaultWidth: number = 100) {
  if (isIconOnlyAction(columnConfig)) {
    return 25; // default width for utility columns (with icon-only actions)
  }

  return columnConfig.width ?? defaultWidth;
}
